"use strict";

exports.__esModule = true;
exports.default = void 0;

var _universalEnv = require("universal-env");

// eslint-disable-next-line import/no-extraneous-dependencies
var Cache = /*#__PURE__*/function () {
  function Cache() {}

  var _proto = Cache.prototype;

  _proto.getSelector = function getSelector(selector, context) {
    if (_universalEnv.isMiniApp && !_universalEnv.isWeb) {
      var selectorQuery = my.createSelectorQuery().selectAll(selector);
      return selectorQuery;
    } else if (_universalEnv.isWeChatMiniProgram && !_universalEnv.isWeb) {
      if (!context) {
        context = wx;
      }

      var _selectorQuery = context === null || context === void 0 ? void 0 : context.createSelectorQuery().selectAll(selector);

      return _selectorQuery;
    } else {
      // Transform NodeList to Array
      var nodes = Array.from(document.querySelectorAll(selector));
      return nodes;
    }
  };

  return Cache;
}();

exports.default = Cache;